import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CallbackPage } from "./pages/CallbackPage";
import { Launcher } from "./pages/Launcher";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/callback" element={<CallbackPage />} />
        <Route index element={<Launcher />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
